export function isFacebook() {
  if (document.referrer && document.referrer !== '') {
    return document.referrer.toLowerCase().includes('facebook');
  } else {
    return false;
  }
}